import Tooltip from "../gui/Overlay/Tooltip"
import { Cols, PriceCols } from "../shared/Consts"
import PortUtils from "./PortUtils"

export default class TableUtils {
    static align(col:string) {
        switch(col){
        case PriceCols.ticker:
        case PriceCols.sector:
        case PriceCols.frequency:
        case Cols.note:
        case Cols.name:
        case Cols.accountId:
        case Cols.type:
        case Cols.id:
        case Cols.date: return "align-left"
        default:        return "align-right"
        }
    }    

    static header(col:string) {
        const tooltip = PortUtils.hint(col)
        if (tooltip=="") return PortUtils.label(col)
        else return <Tooltip tooltip={tooltip} key={col}><span>{PortUtils.label(col)}</span></Tooltip>
    }    
}